/**
 * Authentication utility functions
 */

export interface AuthUser {
  id: string;
  username: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  role: string;
  tenantId: string;
}


 export function getCurrentUser(): AuthUser | null {
  const userStr = localStorage.getItem("user");
  if (!userStr) return null;
  
     try {
    return JSON.parse(userStr) as AuthUser;
  } catch {
    return null;
  }
}


  export function getTenantId(): string  | null {
  return localStorage.getItem("tenant_id");
}


export function  getAuthToken(): string | null {
  return localStorage.getItem("auth_token");
}


export function isAuthenticated(): boolean {
  return !!getAuthToken() && !!getTenantId();
}


  export function clearAuth(): void {
  localStorage.removeItem("auth_token");
  localStorage.removeItem("tenant_id");
  localStorage.removeItem("user");
}


 export function setAuth(token: string, tenantId: string, user: AuthUser): void {
  localStorage.setItem("auth_token", token);
  localStorage.setItem("tenant_id", tenantId);
  localStorage.setItem("user", JSON.stringify(user));
}

